import { Flex, Box, Text, Input, Textarea, Button, Heading, useColorModeValue, IconButton, FormControl } from "@chakra-ui/react";
import React, { useState } from "react";
import Footer from "../../components/footer/footer";
import Boxx from "../../components/common/boxhome/boxx";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { useForm } from "react-hook-form";
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import Swal from "sweetalert2";
import axios from "axios";

interface ContactusValues {
    full_name: string,
    email: string;
    remarks: string
}

interface ResponseType {
    success?: boolean,
    statusCode?: number,
    message?: string,

}

const Contact: React.FC = () => {
    const [fullName, setFullName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [remarks, setRemarks] = useState<string>("");
    const [message, setMessage] = useState<string>("");

    const contactusSchema: yup.Schema<ContactusValues> = yup.object().shape({
        full_name: yup.string().required("Full Name Is Required"),
        email: yup.string().email("Invalid Email Formate").required("Email Is Required"),
        remarks: yup.string().required("Remarks Is Required")
    })

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(contactusSchema)
    })


    const handleSubmitApi = async (data: ContactusValues) => {
        
        try {
            const response = await axios.post("https://api.raretoss.com/contactus", data, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            

           const responseData : ResponseType = response["data"]
            console.log("response data set")


            Swal.fire({
                position: "center",
                icon: "success",
                title: responseData.message,
                showConfirmButton: false,
                timer: 1500,
            });
        } catch (error) {

            if (error && typeof error === "object" && "response" in error && "data" in error.response) {

                const responseData : ResponseType = error.response.data

                console.log("in if condition", responseData, responseData.message)
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: responseData.message,
                    showConfirmButton: false,
                    timer: 1500,
                });


            }else{

                 Swal.fire({
                position: "center",
                icon: "error",
                title: "Network Error",
                showConfirmButton: false,
                timer: 1500,
            });

            }

           
        }
    };


    const handleOnSubmit = (data: ContactusValues) => {
        handleSubmitApi(data)
    }


    const bg = useColorModeValue('white', '#1C1C1C')
    const color = useColorModeValue('#FFFFF', 'white')
    return (
        <Flex
            bg={bg}
            direction="column"
            align="center"
            justify="center"
            width="100%"
            px={{ base: 4, md: 10 }}
            py={{ base: 6, md: 10 }}
            // color="white"
            position="relative"
        >
            <Box mt={{ base: "", md: "50px" }}>
                <Text fontSize="28px" color={color} fontFamily="'Gilroy-Regular', sans-serif" lineHeight='36px'>
                    Contact Us
                </Text>

            </Box>
            <Box
                display={{ base: "block", md: "none" }}
                textAlign="center"
                mb="30px"
                mt='51px'
            >
                <Text fontSize="32px" color={color} fontFamily="'Gilroy-SemiBold', sans-serif" lineHeight='40px'>
                    Let’s have a
                </Text>
                <Text fontSize="32px" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif">
                    Cup of Coffee
                </Text>
            </Box>

            {/* Header for Larger Screens */}
            <Box
                as="header"
                width="100%"
                maxWidth="1720px"
                textAlign="center"
                mb="100px"
                mt={{ base: "43px", md: "51px" }}
                opacity="1"
                display={{ base: "none", md: "block" }}
            >
                <Text
                    fontFamily="'Gilroy-SemiBold', sans-serif"
                    fontSize={{ base: "24px", md: "40px", lg: "48px" }}
                    color={color}
                >
                    Let’s <span style={{ color: "#FE3A3A" }}>Toss</span> Ideas and Create Something <span style={{ color: "#FE3A3A" }}>Rare</span>
                </Text>
            </Box>

            <Flex
                width="100%"
                maxWidth="1720px"
                direction={{ base: "column", md: "row" }}
                justify="space-between"
                gap={{ base: "20px", md: "20px" }}
                height="auto"
                opacity="1"
                color={color}
            >
                <form onSubmit={handleSubmit(handleOnSubmit)} style={{ width: "100%" }}>
                    {/* Full Name Input */}
                    <FormControl isInvalid={!!errors.full_name} mb={4}>
                        <Box position="relative">
                            <Input
                                id="fullName"
                                placeholder="Full Name"
                                borderColor="red.500"
                                color="red.500"
                                _placeholder={{
                                    color: useColorModeValue('#1C1C1C', 'white'),
                                    fontFamily: "'Gilroy-Regular', sans-serif",
                                    fontSize: "16px",
                                }}
                                width="100%"
                                height="80px"
                                borderWidth="2px"
                                borderRadius="10px"
                                fontFamily="'Gilroy-SemiBold', sans-serif"
                                _focus={{
                                    borderColor: "red.500",
                                    boxShadow: "none",
                                }}
                                _hover={{
                                    borderColor: "red.500",
                                }}
                                {...register("full_name", { required: "Full Name is required" })}
                            />
                            {errors.full_name && (
                                <Text
                                    color="red.500"
                                    fontSize="12px"
                                    position="absolute"
                                    top="100%"
                                    left="5px"
                                    fontFamily="'Gilroy-Regular', sans-serif"
                                >
                                    {errors.full_name.message}
                                </Text>
                            )}
                        </Box>
                    </FormControl>

                    {/* Email Input */}

                    <FormControl isInvalid={!!errors.email} mb={4}>
                        <Box position="relative">
                            <Input
                                id="email"
                                placeholder="Email"
                                type="email"
                                borderColor="red.500"
                                color="red.500"
                                _placeholder={{
                                    color: useColorModeValue('#1C1C1C', 'white'),
                                    fontFamily: "'Gilroy-Regular', sans-serif",
                                    fontSize: "16px",
                                }}
                                width="100%"
                                height="80px"
                                borderWidth="2px"
                                borderRadius="10px"
                                fontFamily="'Gilroy-SemiBold', sans-serif"
                                _focus={{
                                    borderColor: "red.500",
                                    boxShadow: "none",
                                }}
                                _hover={{
                                    borderColor: "red.500",
                                }}

                                {...register("email", {
                                    required: "Email is required",
                                    pattern: {
                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                        message: "Please enter a valid email address",
                                    },
                                })}
                            />
                            {errors.email && (
                                <Text
                                    color="red.500"
                                    fontSize="12px"
                                    position="absolute"
                                    top="100%"
                                    left="5px"
                                    fontFamily="'Gilroy-Regular', sans-serif"
                                >
                                    {errors.email.message}
                                </Text>
                            )}
                        </Box>
                    </FormControl>

                    {/* Remarks Textarea */}
                    <FormControl isInvalid={!!errors.remarks} mb={4}>
                        <Box position="relative">
                            <Textarea
                                id="remarks"
                                placeholder="Remarks"
                                borderColor="red.500"
                                color="red.500"
                                _placeholder={{
                                    color: useColorModeValue('#1C1C1C', 'white'),
                                    fontFamily: "'Gilroy-Regular', sans-serif",
                                    fontSize: "16px",
                                }}
                                width="100%"
                                height="230px"
                                borderWidth="2px"
                                borderRadius="10px"
                                fontFamily="'Gilroy-SemiBold', sans-serif"
                                _focus={{
                                    borderColor: "red.500",
                                    boxShadow: "none",
                                }}
                                _hover={{
                                    borderColor: "red.500",
                                }}
                                {...register("remarks", { required: "Remarks are required" })}
                            />
                            {errors.remarks && (
                                <Text
                                    color="red.500"
                                    fontSize="12px"
                                    position="absolute"
                                    top="240px"
                                    left="5px"
                                    fontFamily="'Gilroy-Regular', sans-serif"
                                >
                                    {errors.remarks.message}
                                </Text>
                            )}
                        </Box>
                    </FormControl>

                    {/* Submit Button */}
                    <Button
                        type="submit"
                        bg="red.500"
                        color={"white"}
                        fontSize={{ base: "16px", md: "22px" }}
                        _hover={{ bg: "red.600" }}
                        width={{ base: "100%", md: "50%" }}
                        fontFamily="'Gilroy-SemiBold', sans-serif"
                        height={{ base: "44px", md: "50px" }}
                        mt={3}
                    >
                        Send a Message
                    </Button>
                </form>

                {/* Text Section */}
                <Box width={{ base: "100%", md: "100%" }} textAlign={{ base: "center", md: "left" }}>
                    <Text
                        textAlign="justify"
                        fontFamily="'Gilroy-Regular', sans-serif"
                        fontSize={{ base: "16px", md: "28px" }}
                        lineHeight={{ base: "24px", md: "36px" }}
                        fontWeight="400"
                        letterSpacing="0.15px"
                        mb={8}
                    >
                        At RareToss Mediaworks, we’re all about delivering unique solutions that help your business thrive. Whether you’re looking to grow your brand, enhance your digital presence, or explore new marketing opportunities, we’re here to collaborate and make it happen. Reach out to us today, and let’s start crafting something extraordinary together.
                    </Text>
                    <Box width={{ base: "100%", md: "50%" }}>
                        <Flex align="center" mb={4}>
                            <img src="/assets/images/svg/sms.svg" alt="sms" />
                            <Text fontSize={{ md: "28px", base: "16px" }} ml={3} fontFamily="'Gilroy-Regular', sans-serif">
                                example@gmail.com
                            </Text>
                        </Flex>
                        <Flex align="center" mb={4}>
                            <img src="/assets/images/svg/call.svg" alt="call" />
                            <Text fontSize={{ md: "28px", base: "16px" }} ml={3} fontFamily="'Gilroy-Regular', sans-serif">
                                +91 36542 25631
                            </Text>
                        </Flex>
                        <Flex align="center" mb={4}>
                            <img src="/assets/images/svg/location.svg" alt="location" />
                            <Text fontSize={{ md: "28px", base: "16px" }} ml={3} fontFamily="'Gilroy-Regular', sans-serif">
                                Abu Dhabi, UAE
                            </Text>
                        </Flex>
                    </Box>
                </Box>
            </Flex>

            <Box mt={{ base: "30px", md: "100px" }}>
                <Text fontSize={{ base: "12px", md: "28px" }} color={color} fontFamily="'Gilroy-Regular', sans-serif" lineHeight='36px'>
                    Frequently Asked Questions
                </Text>

            </Box>
            <Box
                mt="3%"
                textAlign="center"
                width="auto"
                height="auto"
                position="relative"
                left="auto"
                gap="0px"
                opacity="1"
            >
                <Heading
                    fontFamily="Gilroy-SemiBold"
                    fontSize={{ base: '32px', md: '64px' }}
                    fontWeight="400"
                    lineHeight={{ base: '40px', md: '78px' }}
                    letterSpacing="-0.25px"
                >

                    <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>Questions ?</span>
                </Heading>
                <Heading
                    fontFamily="Gilroy-SemiBold"
                    fontSize={{ base: '32px', md: '64px' }}
                    fontWeight="400"
                    lineHeight={{ base: '40px', md: '78px' }}
                    letterSpacing="-0.25px"
                    color={color}
                >
                    Your   <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>Answers</span>  are here
                </Heading>
            </Box>

            <BrandingInfoList />

            {/* <Boxx /> */}
            <Footer />


        </Flex>
    );
};

interface BrandingInfoProps {
    title: string;
    content: string;
}
const BrandingInfo: React.FC<BrandingInfoProps> = ({ title, content }) => {
    const [isOpen, setIsOpen] = useState(false);
    const bg = useColorModeValue('red.500', 'red.200')
    const color = useColorModeValue('#FFFFF', 'white')
    return (
        <Box
            maxW="auto"
            borderRadius={{ base: '10px', md: '20px' }}
            color={color}
            border={isOpen ? '1px solid #FE3A3A' : 'none'}
            overflow="hidden"
            mt={{ base: '10px', md: '50px' }}
        >
            <Box
                display="flex"
                justifyContent="space-between"
                onClick={() => setIsOpen(!isOpen)}
                cursor="pointer"
                alignItems="center"
                border={isOpen ? '2px solid #FE3A3A' : 'none'}
                borderRadius="md"
                p={{ base: '10px', md: '20px' }}
                backgroundColor={isOpen ? '#FE3A3A' : 'transparent'}
            >
                <Text
                    fontFamily="'Gilroy-SemiBold', sans-serif"
                    fontWeight="400"
                    fontSize={{ base: "16px", md: "32px" }}
                    lineHeight={{ base: "24px", md: "40px" }}
                >
                    {title}
                </Text>
                <IconButton
                    aria-label={isOpen ? "Collapse" : "Expand"}
                    icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    fontSize={{ base: "24px", md: "30px" }}
                    variant="outline"
                    color={color}
                    borderColor="white"
                    _hover={{ bg: 'transparent' }}
                    p={{ base: 1, md: 1 }}
                />
            </Box>
            <Box p={isOpen ? 4 : 0} maxH={isOpen ? 'auto' : '0'} transition="max-height 0.2s ease-out">
                <Text
                    fontFamily="'Gilroy-Regular', sans-serif"
                    fontSize={{ base: "16px", md: "28px" }}
                    lineHeight={{ base: '24px', md: '36px' }}
                >
                    {content}
                </Text>
            </Box>
        </Box>
    );
};
const BrandingInfoList: React.FC = () => {
    return (
        <Box>
            <BrandingInfo title="How can I get in touch with RareToss Mediaworks?" content="You can reach us via the contact form on this page, by email, or through our phone number listed below. We’ll get back to you as soon as possible!" />
            <BrandingInfo title="What services does RareToss Mediaworks offer?" content="We specialize in digital branding, awareness growth, revenue growth, social media management, SEO, and performance marketing. Feel free to ask about any service you're interested in!" />
            <BrandingInfo title="How soon can I expect a response after reaching out?" content="We typically respond within 24-48 hours. If you have an urgent inquiry, feel free to give us a call for faster assistance." />
            <BrandingInfo title="Can I schedule a consultation or meeting?" content="Yes, we’d be happy to schedule a consultation to discuss your needs. Just reach out to us through the form or contact details, and we’ll arrange a suitable time." />
            <BrandingInfo title="Where is RareToss Mediaworks located?" content="We are based in Ahmedabad, India. You can visit us or connect virtually—we’re flexible and happy to meet however works best for you." />
        </Box>
    );
};
export default Contact;